import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationProject } from "./OrganizationProjects.types";

export const updateOrganizationProject = ({
  organizationId,
  projectId,
  data
}: {
  organizationId: string;
  projectId: string;
  data: Partial<Pick<OrganizationProject, "plan" | "support_tier">>;
}) =>
  apiProxyRequest<OrganizationProject>(
    `/organizations/${organizationId}/projects/${projectId}`,
    "PATCH",
    data
  );
